<template>
	<div class="control-buttons-tab">
		<div class="boxFixed">
			<div class="button-list">
				<paiche :selectedRows="selectedRows" @success="success"></paiche>
			</div>
			<div class="button-list">
				<uploadSeal
					:selectedRows="selectedRows"
					@success="success"
				></uploadSeal>
			</div>
			<div class="button-list">
				<transport-feedback
					:selectedRows="selectedRows"
					@success="success"
				></transport-feedback>
			</div>
			<div class="button-list">
				<packinglist
					:selectedRows="selectedRows"
					ref="packinglist"
				></packinglist>
			</div>
			<div class="button-list">
				<customer-files
					:selectedRows="selectedRows"
					@success="success"
				></customer-files>
			</div>
		</div>
	</div>
</template>

<script>
import paiche from "./assignment/paiche";
import packinglist from "./packinglist/packinglist";
import uploadSeal from "./upload-seal/upload-seal";
import transportFeedback from "./transport-feedback/transport-feedback";
import customerFiles from "./customer-files/port-report";
import { assignDriver } from "../api/business-dispatch";
import { trucklist, driverlist } from "../api/basicData";
import { searchReqParam } from "../utils/searchReqParam";
import moment from "moment";

export default {
	name: "control-buttons",
	components: {
		paiche,
		packinglist,
		uploadSeal,
		transportFeedback,
		customerFiles,
	},
	props: {
		selectedRows: {
			type: Array,
			default() {
				return [];
			},
		},
		containerId: {
			type: String,
			default() {
				return "";
			},
		},
	},
	data() {
		return {
			req: searchReqParam(),
			// 派车
			visible_paiche: false,
			confirmLoading_paiche: false,
			visible_box: false,
			confirmLoading_box: false,
			confirmLoading_seal: false,
			form_paiche: {
				truckId: undefined,
				truck: "",
				driverId: undefined,
				driver: {
					name: "",
					mobile: "",
				},
			},
			loading_paiche: false,
			loading: false,

			// 上传箱封照
			form_upload: {
				containerNumber: "",
				containerSeal: "",
				files: [],
			},
			fileList_xh: [],
			fileList_fh: [],
			previewVisible_xh: false,
			previewImage_xh: "",
			previewVisible_fh: false,
			previewImage_fh: "",
			bdstyle: {
				width: "1000px",
				height: "750px",
				color: "black",
			},
			truckList: [],
			driverList: [],
			// 装箱单
			visible_showpackinglist: false,
			// 运输节点反馈
			visible_nodetrace: false,
			confirmLoading_node: false,
			visible_arriveFactory: false,
			current: 3,
		};
	},
	watch: {
		"form_paiche.driverId": {
			handler() {
				this.form_paiche.driver = this.driverList.find((item) => {
					return (
						this.form_paiche.driverId && this.form_paiche.driverId == item.id
					);
				});
				if (!this.form_paiche.driver) {
					this.form_paiche.driver = {
						name: "",
						mobile: "",
					};
				}
			},
		},
		"form_paiche.truckId": {
			handler() {
				this.form_paiche.truck = this.truckList.find((item) => {
					return (
						this.form_paiche.truckId && this.form_paiche.truckId == item.id
					);
				});
				if (!this.form_paiche.truck) {
					this.form_paiche.truck = {
						plateNumber: "",
					};
				}
			},
		},
		fileList_xh: {
			handler() {
				if (this.fileList_xh.length >= 1) {
					this.form_upload.files.push({
						fileType: "CONTAINER_IMAGE",
						url: this.fileList_xh[0].url,
					});
				} else {
					this.form_upload.files = this.form_upload.files.filter((item) => {
						return item.fileType != "CONTAINER_IMAGE";
					});
				}
			},
			deep: true,
		},
		fileList_fh: {
			handler() {
				if (this.fileList_fh.length >= 1) {
					this.form_upload.files.push({
						fileType: "SEAL_IMAGE",
						url: this.fileList_fh[0].url,
					});
				} else {
					this.form_upload.files = this.form_upload.files.filter((item) => {
						return item.fileType != "SEAL_IMAGE";
					});
				}
			},
			deep: true,
		},
	},
	created() {},
	mounted() {
		this.pageInit();
	},
	methods: {
		moment,
		pageInit() {
			trucklist(this.req).then((res) => {
				this.truckList = JSON.parse(res.data).data.list;
			});
			driverlist(this.req).then((res) => {
				this.driverList = JSON.parse(res.data).data.list;
			});
		},
		success(msg) {
			this.$emit("success", msg);
		},
		// 派车
		showPaiche() {
			if (this.selectedRows.length >= 1) {
				this.visible_paiche = true;
			} else {
				this.$message.error("请先选择一个订单！！！");
			}
		},
		cancelPaiche(e) {
			console.log(e);
			this.visible_paiche = false;
			this.form_paiche = {
				truckId: undefined,
				truck: "",
				driverId: undefined,
				driver: {
					name: "",
					mobile: "",
				},
			};
		},
		okPaiche(e) {
			console.log(e);
			// 封装派车请求参数
			let params = {};
			// 司机信息
			params.driverId = this.form_paiche.driverId;
			params.driverName = this.form_paiche.driver.name;
			params.driverPhone = this.form_paiche.driver.mobile;
			// 车辆信息
			params.truckId = this.form_paiche.truckId;
			params.truck = this.form_paiche.truck.plateNumber;
			// 订单号
			params.orderId =
				this.selectedRows.length >= 1 ? this.selectedRows[0].orderId : "";

			// 重新封装请求参数
			this.req.params = params;

			this.confirmLoading_paiche = true;
			assignDriver(this.req).then((res) => {
				// console.log(JSON.parse(res.data));
				let result = JSON.parse(res.data);
				if (result.code == "0") {
					// 成功提示信息
					this.$message.success(result.msg);
					// 重置
					this.emptypaiche();
					// 通知父单元成功消息
					this.$emit("success", result.msg);
				} else if (result.code == "dat-INVALID_OPERATION") {
					this.$message.error("此订单已取消，无法派车");
					// 重置
					this.emptypaiche();
					this.$emit("success", result.msg);
				} else {
					// 失败提示信息
					this.$message.error("司机姓名或车牌号不能为空");
					this.confirmLoading_paiche = false;
				}
			});
		},
		emptypaiche() {
			// 重置
			this.visible_paiche = false;
			this.form_paiche = {
				truckId: undefined,
				truck: "",
				driverId: undefined,
				driver: {
					name: "",
					mobile: "",
				},
			};
			this.confirmLoading_paiche = false;
		},
		resetPaiche() {
			this.form_paiche = {
				truckId: undefined,
				truck: "",
				driverId: undefined,
				driver: {
					name: "",
					mobile: "",
				},
			};
		},
		// 装箱单
		showPackinglist() {
			this.$refs["packinglist"].showPackinglist();
		},
		// 运输节点跟踪
		showNodetrace() {
			if (this.selectedRows.length >= 1) {
				console.log(this.selectedRows);
				if (this.selectedRows[0].orderStatus.value == "已取消") {
					this.$message.error("当前订单已取消无法反馈运输状态！");
					return;
				}
				this.visible_nodetrace = true;
			} else {
				this.$message.error("请先选择一个订单！！！");
			}
		},
		cancelNodetrace() {
			this.visible_nodetrace = false;
		},
		cancelShowNodetrace() {
			this.visible_nodetrace = false;
		},
		onChange(value, dateString) {
			console.log("Selected Time: ", value);
			console.log("Formatted Selected Time: ", dateString);
		},
		onOk(value) {
			console.log("onOk: ", value);
		},
		show_arriveFactory(a) {
			this.$refs["feedback"].visible = true;
			console.log(a);
		},
	},
};
</script>
<style lang="less" scoped>
.boxFixed {
	float: left;
}
.button-list {
	display: inline-block;
	margin-right: 8px;
}
.ant-upload-text {
	font-size: 12px;
}
</style>
